<template>
  <div id='Logon' >
    <plugin />
	<Alert :alertMsg='alertMsg' v-if='alertShow'  @alertShowFN="getMsgFormAlert"/>
    <!-- <div style='width:1rem;height:1rem;'>1rem</div>
    <div style='width:3.75rem;height:1rem;'>3.75rem</div>
    <div style='width:7.5rem;height:1rem;'>7.5rem</div> -->
    <div class='logoBox'>
          <img src="../assets/logo3.png"/>
    </div>
    <div>
        <div class='inputRow'>
            <input type="number" placeholder="请输入手机号…"  v-model="phoneNumber" class='qInput'  maxlength="11" oninput='if(value.length>11)value=value.slice(0,11)' />
        </div>
        <div class='inputRow'>
            <input v-model="password" type="number" placeholder="请输入验证码…" class='qInput'  @blur="blurs">
            <div 	@click="postPassWord" v-if='passwordShow' class='pssswordBtn1'>获取验证码</div>
            <div  v-else class='pssswordBtn2'>剩余{{second}}s</div>
        </div>
    </div>
    <div style='height:1rem;'></div>
    <div class='logonBtn' @click="postLogon">登录</div>

    <div class='policy'>一旦登录，即表明你同意NUTRIPACKS的 <a @click="toPrivacy">隐私政策</a>和<a @click="toClause">使用条款</a>。</div>
  </div>
</template>

<script>

import plugin from '@/components/plugin.vue'
import Alert from '@/popup/Alert.vue'
export default {
  name: 'Login',
  components: {
    plugin,
	Alert
  },
  data:function () {
    return{
      phoneNumber:"",               //手机号
      password:"",                  //验证码
      second:60,                    //重发验证码剩余秒
      passwordShow:true,            //发送验证码按钮是否显示
	  alertShow:false,
	  alertMsg:"",
     
    }
  },
  beforeCreate:function() {
	
	
   	
  },
  created:function(){

  },
  computed:{
  },
  mounted:function(){
   
    

  },
  methods: {   
	// 解决iphone7输入后固定定位偏离问题
   blurs(){
   		window.scroll(0, 0);
   	},
    // 发送验证码
    postPassWord(){
      if(this.phoneNumber.length<11){
		   this.alertFN("请输入正确手机号码")
		return
      }                   
			let that = this	
            this.axios({
                       method: 'post',
                       url:"sms/sendSms",
                       data: {
			phone:this.phoneNumber,
			code_type:2,
                       }
                     }).then(res=>{
			if(res.data.code==1){
                           that.second=60
		 	   that.passwordShow = false
			   that.autolog()	
			}else{
				that.alertFN(res.data.msg)
			}
                      	
                     })
    },
    // 计时
   autolog(){
      setTimeout(()=>{
        if(this.second<1){
          this.passwordShow = true
          return
        }
        this.second = this.second - 1
        this.autolog()
      },1000)
   },
   // 手机注册登录
   postLogon(){
      if(this.phoneNumber.toString().length!=11){
		  this.alertFN("请输入正确手机号")
        return
      }
      if(!this.password){
		  this.alertFN("请输入验证码")
        return
      }
      this.axios({
                      method: 'post',
                      url:"h5api/phoneRegister",
                      data: {
						phone:this.phoneNumber,
						check_code:this.password,
						share_id:0,
                      }
                }).then(res=>{
         
                  if(res.data.code==0&&res.data.memberInfo){
					this.$store.commit("saveMemberId",res.data.memberInfo.member_id)
					if(res.data.memberInfo.nickName){
						this.$store.commit("saveMember",res.data.memberInfo)
					}
					
					// this.$router.go(-1)
					 this.$router.replace('/')
					
					 
					
				  }else{
					  this.alertFN(res.data.msg)
				
				  }
                  
                })
   },
   // 隐私政策
   toPrivacy(){
	   this.$router.push({name:"Privacy"})
   },
   // 使用条款
   toClause(){
	   this.$router.push({name:"clause"})
   },
   // 页面提示
   alertFN(msg){
	   this.alertShow=true
	   this.alertMsg=msg
   },
   closeAlertShow(){
	 this.alertShow = false  
   },
   getMsgFormAlert(eve){
	   console.log(eve)
   },
  },
}
</script>  

<style>
#Logon{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
}
.logoBox{
  height:5rem;
  position: relative;
}
.logoBox img{
  width: 3.75rem;
  position: absolute;
  left: 50%;
  top:50%;
  transform: translate(-50%, -50%); 
}
.inputRow{
  height: 0.8rem;
  margin-bottom: 0.2rem;
  display: flex;
  padding: 0 0.5rem;
}
.qInput{
  height:0.8rem;
  flex: 1;
  border-radius: 0.1rem;
  outline: none;
  border:none;
  padding: 0 0.2rem;
}
.pssswordBtn1{
  width:1.6rem;
  margin-left:0.5rem;
  font-size: 0.24rem;
  position: relative;
  top:0.1rem;
  height:0.6rem;
  text-align: center;
  line-height: 0.6rem;
   background:rgba(194,94,77,1);
  border-radius:0.5rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
}
.pssswordBtn2{
  width:2rem;
  height:0.8rem;
  text-align: center;
  line-height: 0.8rem;
}
.logonBtn{
  width:6.5rem;
  height:1rem;
  line-height: 1rem;
  text-align:center;
  background:rgba(194,94,77,1);
  border-radius:0.5rem;
  font-size:0.31rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  margin:0 auto;
}
.policy{
  width:5rem;
  margin:1rem auto;
}
</style>